module.exports = __webpack_public_path__ + "img/profile_active.eb8d22b1.svg";